export default __webpack_public_path__ + "static/media/kitchen3-afterB-1024w.16048bcd.webp";